import Vue from 'vue'
import VueI18n from 'vue-i18n';
let _Vue = Vue;


if (window.Vue) {
    _Vue = window.Vue
    _Vue.use((window as any).VueI18n);
} else {
    _Vue = Vue
    _Vue.use(VueI18n)
}

//i18n

import messages from "./translate";


import enLocale from 'element-ui/lib/locale/lang/en'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'

let _VueI18n = VueI18n;
if ((window as any).VueI18n) {
    _VueI18n = (window as any).VueI18n;
}

const i18n = new _VueI18n({
    locale: 'zh-hk', // set locale
    messages: {
        en: { ...messages.en, ...enLocale },
        "zh-hk": { ...messages["zh-hk"], ...twLocale },
    }
})

import * as components from './components'
Object.keys(components).forEach(k => {
    _Vue.component(k, (components as any)[k]);
});


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



import SlideUpDown from 'vue-slide-up-down';

import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas, far, fab)

_Vue.use(ElementUI, {
    i18n: (key: string, value: string) => i18n.t(key, value)
});
_Vue.use(SlideUpDown);
_Vue.component('slide-up-down', SlideUpDown);
_Vue.component('font-awesome-icon', FontAwesomeIcon)



import VueRouter from 'vue-router'
_Vue.use(VueRouter)

import routes from './routes'
import './assets/theme/tailwind.css'


const router = new VueRouter({
    mode: 'history',

    routes: [
        {
            path: "/crm/",
            component: {
                template: '<router-view></router-view>'
            },
            children: routes.map(route => {
                if (route.path.startsWith('/')) {
                    route.path = route.path.substring(1)
                }
                return route;
            })
        },
        {
            path: "/en/crm/",
            component: {
                template: '<router-view></router-view>'
            },
            children: routes.map(route => {
                route = Object.assign({}, route);

                if (route.name) {
                    route.name = `en-${route.name}`
                }
                if (route.path.startsWith('/')) {
                    route.path = route.path.substring(1)
                }
                return route;
            })
        },
    ]
})


router.beforeEach((to, from, next) => {
    
    if (window.location.pathname.startsWith('/en/')) {
        i18n.locale = 'en'
    } else {
        i18n.locale = 'zh-hk'
    }
    localStorage.setItem('language', i18n.locale)
    next()
});


_Vue.config.productionTip = false;

(window as any).crm_vm = new _Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')

